import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import headerVideo from "../styles/media/webpage-hero-vid.mp4";
import headerPoster from "../styles/media/headerBW.png";

export const Header = () => {
  const { t } = useTranslation();

  return (
    <Suspense fallback="...loading">
      <header id="header">
        <div className="intro">

          <video
            className="intro-video"
            autoPlay
            muted
            loop={false}
            playsInline
            poster={headerPoster}
          >
            <source src={headerVideo} type="video/mp4" />
          </video>

          <div className="intro-overlay" />
          <div className="intro-grid" />

          <div className="intro-content">
            <span className="hero-badge fadeInUpBig">{t("Header.badge")}</span>

            <h2 className="hero-title fadeInRightBigHeader">
              {t("Header.title1")} <br />
              <span className="text-accent">{t("Header.title2")}</span>
            </h2>

            <p className="hero-description fadeInLeftBigHeader">
              {t("Header.description")}
            </p>

            <div className="hero-actions fadeInUpBig">
              <a
                href="https://calendly.com/consulting-kallideus/30min"
                target="_blank"
                rel="noreferrer"
                className="btn-custom"
              >
                {t("Header.button")}
              </a>
              <a href="#contact" className="btn-custom" >
                {t("Header.button2")}
              </a>
            </div>
          </div>

        </div>
      </header>
    </Suspense>
  );
};
